import { render, staticRenderFns } from "./ArrivaStatisticsedit.vue?vue&type=template&id=6784f626&scoped=true"
import script from "./ArrivaStatisticsedit.vue?vue&type=script&lang=js"
export * from "./ArrivaStatisticsedit.vue?vue&type=script&lang=js"
import style0 from "./ArrivaStatisticsedit.vue?vue&type=style&index=0&id=6784f626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784f626",
  null
  
)

export default component.exports